import { render, staticRenderFns } from "./YearlySchedule.vue?vue&type=template&id=36bef1b3&scoped=true&"
import script from "./YearlySchedule.vue?vue&type=script&lang=js&"
export * from "./YearlySchedule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36bef1b3",
  null
  
)

export default component.exports